<div class="row main-footer justify-content-center primary-color">
  <div class="col-md-10 ">
    <div class="row" style="padding: 20px;">
      <div class="col-md-3  col-12 border-right blogo">
        <div class="row justify-content-center" >
          <div class="col-md-10 " style="text-align: center ;margin-top: 2.8em;">
            <a routerLink="/" routerLinkActive="active">
              <img *ngIf="siteType === 'default'" class="footer-logo" alt="Operé par Clem" src="../../assets/img/Picto_Global/LogoBlanc_by.png">
              <img *ngIf="siteType === 'clem'" class="footer-logo" src="../../assets/img/Picto_Global/LogoBlanc_Clem.png">
              <img *ngIf="siteType === 'remi'" class="footer-logo" src="../../assets/img/Remi/blanc.png">
            </a>
          </div>


          <div class="col-md-10 mt-2" style="text-align: center">
           
             <!-- facebook -->
            <a *ngIf="config?.footer_facebook" alt="Clem" [href]="config?.footer_facebook" target="_blank" class="mr-2">
              <img class="social-icon" src="../../../assets/img/ReseauxSociaux/Picto_Facebook.svg" />
            </a>
            <!-- instagram -->
            <a  *ngIf="config?.footer_instagram" [href]="config?.footer_instagram" target="_blank" class="mr-2">
              <img class="social-icon" src="../../../assets/img/ReseauxSociaux/Picto_Instagram.svg" />
            </a>
            <!-- linkedin -->
            <a  *ngIf="config?.footer_linkedin" [href]="config?.footer_linkedin" target="_blank" class="mr-2">
              <img class="social-icon" src="../../../assets/img/ReseauxSociaux/Picto_LinkedIn.svg" />
            </a>
            <!-- Site -->
            <a  *ngIf="config?.footer_site" [href]="config?.footer_site" target="_blank" class="mr-2">
              <img class="social-icon" src="../../../assets/img/ReseauxSociaux/site.svg" />
            </a>
            <!-- Youtube -->
            <a  *ngIf="config?.footer_youtube" [href]="config?.footer_youtube" target="_blank" class="mr-2">
              <img class="social-icon" src="../../../assets/img/ReseauxSociaux/youtube.svg" />
            </a>
             <!-- X -->
            <a  *ngIf="config?.footer_x" [href]="config?.footer_x" target="_blank" class="mr-2">
              <img class="social-icon" src="../../../assets/img/ReseauxSociaux/x.svg" />
            </a>
            <!-- facebook -->
            <a  *ngIf="config?.footer_facebook1" [href]="config?.footer_facebook1" target="_blank">
                <img class="social-icon" src="../../../assets/img/ReseauxSociaux/Picto_Facebook.svg" />
            </a>

          </div>



        </div>
      </div>
      <div class="col-md-3  col-12">
        <div class="row">
          <h2 class="col-md-12">{{ 'FOOTER.INFO_UTILES.TITLE' | translate }}</h2>
          <a class="col-md-12" [routerLink] = "['/']"  fragment="ccm" >
            <h5 class="col-md-12" style="color: white !important">{{ 'FOOTER.INFO_UTILES.PARA1' | translate }}</h5>
          </a>
          <a class="col-md-12" href="https://www.clem-e.com/qui-sommes-nous" target="_blank">
            <h5 class="col-md-12" style="color: white !important">{{ 'FOOTER.INFO_UTILES.PARA2' | translate }}</h5>
          </a>
          <a class="col-md-12" routerLink="faq" >
            <h5 class="col-md-12" style="color: white !important">{{ 'FOOTER.INFO_UTILES.PARA3' | translate }}</h5>
          </a>
          <!-- <a  class="col-md-12" href="https://www.clem-e.com/">
            <h5 class="col-md-12" style="color: white !important">Clem' pour les professionnels</h5>
          </a> -->
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row">
          <h2 class="col-md-12">{{ 'FOOTER.INFO_LEGALES.TITLE' | translate }}</h2>
          <a class="col-md-12" routerLink="cgu"><h5 class="col-md-12" >{{ 'FOOTER.INFO_LEGALES.PARA1' | translate }}</h5></a>
          <a  class="col-md-12" routerLink="mention-legales"><h5 class="col-md-12" >{{ 'FOOTER.INFO_LEGALES.PARA2' | translate }}</h5></a>
          <a class="col-md-12" routerLink="politique-de-confidentialite"><h5 class="col-md-12" >{{ 'FOOTER.INFO_LEGALES.PARA3' | translate }}</h5></a>
        </div>
      </div>

      
      <div class="col-md-3 col-12">
        <div class="row">
          <h2 class="col-md-12">{{ 'FOOTER.CONTACT.TITLE' | translate }}</h2>
          <h5 class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_1' | translate }}</h5>
          <!-- Remi ------------------------------------------->
          <h5 *ngIf="siteType === 'remi'" class="col-md-12">{{ 'FOOTER.CONTACT.PARA2' | translate }}</h5>
          <h5 *ngIf="siteType === 'remi'" class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_1_REMI' | translate }}</h5>
          <h5 *ngIf="siteType === 'remi'" class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_2_REMI' | translate }}</h5>
          <!-- Remi ------------------------------------------->

          <!-- Clem ------------------------------------------->
          <h5 *ngIf="siteType === 'clem'" class="col-md-12">{{ 'FOOTER.CONTACT.PARA2' | translate }}</h5>
          <h5  *ngIf="siteType === 'clem'"  class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_2' | translate }}</h5>
          <h5  *ngIf="siteType === 'clem'"  class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_3' | translate }}</h5>
          <!-- Clem ------------------------------------------->

          <!-- default ------------------------------------------->
          <h5 *ngIf="siteType === 'default'" class="col-md-12">{{ 'FOOTER.CONTACT.PARA2' | translate }}</h5>
          <h5  *ngIf="siteType === 'default'"  class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_2' | translate }}</h5>
          <h5  *ngIf="siteType === 'default'"  class="col-md-12">{{ 'FOOTER.CONTACT.PARA1_3' | translate }}</h5>
          <!-- default ------------------------------------------->

          <a href="https://www.clem-e.com/contactusager" target="_blank"><h5 class="col-md-12" ><b>{{ 'FOOTER.CONTACT.PARA5' | translate }}</b></h5></a>
          <br>
          <h5 class="col-md-12"> {{ 'FOOTER.CONTACT.PARA3_1' | translate }}</h5>
          <h5 class="col-md-12">{{ 'FOOTER.CONTACT.PARA4' | translate }}</h5>
          

        </div>
      </div>

    </div>
  </div>








<!--   
  <div class="col-md-3 col-12 d-md-none">
      <div class="row" style="padding: 20px;">
          <div class="col-md-3  col-12 ">
            <div class="row justify-content-center" style="height: 100%">
              <div class="col-md-10" style="text-align: center">
                <a routerLink="/" routerLinkActive="active">
                  <img style="width:65%;" src="../../assets/img/Picto_Global/LogoBlanc_Clem.png">
                </a>
              </div>
              <div class="col-md-10" style="text-align: center">
                <a href="https://twitter.com/Clem_mobi?lang=fr">
                  <img style="width:10%;" src="../../../assets/img/ReseauxSociaux/Picto_Twitter.svg" />
                </a>
                <a href="https://www.facebook.com/clem.mobilite/?fref=ts">
                  <img style="width:10%;" src="../../../assets/img/ReseauxSociaux/Picto_Facebook.svg" />
                </a>
                <a href="https://www.instagram.com/clem.mobi/">
                  <img style="width:10%;" src="../../../assets/img/ReseauxSociaux/Picto_Instagram.svg" />
                </a>
                <a href="https://www.linkedin.com/company/mopeasy/">
                  <img style="width:10%;" src="../../../assets/img/ReseauxSociaux/Picto_LinkedIn.svg" />
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-3  col-12">
            <div class="row">
              <h2 class="col-md-12">Informations utiles</h2>
              <a class="col-md-12" href="#ccm">
                <h5 class="col-md-12"  style="color: white !important; ">Comment ça marche ?</h5>
              </a>
              <a class="col-md-12" href="https://www.clem-e.com/qui-sommes-nous">
                <h5 class="col-md-12" style="color: white !important; ">Qui sommes-nous ?</h5>
              </a>
              <a  class="col-md-12" href="https://www.clem-e.com/">
                <h5 class="col-md-12" style="color: white !important; ">Clem' pour les professionnels</h5>
              </a>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row">
              <h2 class="col-md-12" >Informations Légales</h2>
              <h5 class="col-md-12" >Conditions générales d'utilisation</h5>
              <h5 class="col-md-12" >Mention légales</h5>
              <h5 class="col-md-12" >Politique de confidentialité</h5>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="row">
              <h2 class="col-md-12" >Nous contacter</h2>
              <h5 class="col-md-12" >Service client : <b>01 86 86 85 85</b></h5>
              <h5 class="col-md-12" >De 9h à 12h et de 14h a 18h</h5>
              <h5 class="col-md-12" >du lundi au vendredi</h5>
              <br>
              <h5 class="col-md-12" >Assistance technique <b>24/7j</b></h5>
              <h5 class="col-md-12" >Numéro disponible sur votre</h5>
              <h5 class="col-md-12" >Confirmation de réservation</h5>
              <a href="https://www.clem-e.com/contact"><h5 class="col-md-12" ><b>Envoyer un mail</b></h5></a>
    
            </div>
          </div>
    
        </div>  </div> -->
</div>
